import { render, staticRenderFns } from "./ProcessActionLayout.vue?vue&type=template&id=8b8531ea&scoped=true&"
import script from "./ProcessActionLayout.vue?vue&type=script&lang=js&"
export * from "./ProcessActionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8531ea",
  null
  
)

export default component.exports